(() => {
  const prioritise = async (grid) => {
    if (grid.dataset.rankingStarted) return;
    grid.dataset.rankingStarted = 'true';
    const root = grid.closest('.inf-collection');
    const status = root.querySelector('[data-ranking-status]');
    const nav = root.querySelector('.inf-collection__pagination');
    const pageCount = Number(grid.dataset.pages);
    const pageSize = Number(grid.dataset.pageSize);
    const initialPage = Number(grid.dataset.page);
    root.setAttribute('aria-busy', 'true');
    try {
      const pages = new Array(pageCount);
      pages[initialPage - 1] = [...grid.querySelectorAll('[data-merchandising-tier]')];
      const missing = Array.from({ length: pageCount }, (_, i) => i).filter((i) => i !== initialPage - 1);
      let cursor = 0;
      await Promise.all(Array.from({ length: Math.min(4, missing.length) }, async () => {
        while (cursor < missing.length) {
          const page = missing[cursor++];
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', grid.dataset.section);
          url.searchParams.set('page', page + 1);
          const response = await fetch(url, { headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error('Collection unavailable');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fetchedGrid = document.getElementById(grid.id);
          if (!fetchedGrid) throw new Error('Collection unavailable');
          pages[page] = [...fetchedGrid.querySelectorAll('[data-merchandising-tier]')];
        }
      }));
      const cards = pages.flat().sort((a, b) => Number(a.dataset.merchandisingTier) - Number(b.dataset.merchandisingTier));
      const renderPage = (number, navigate = false) => {
        const page = Math.max(1, Math.min(pageCount || 1, number));
        grid.replaceChildren(...cards.slice((page - 1) * pageSize, page * pageSize));
        if (nav) {
          nav.replaceChildren();
          const addLink = (number, text, label) => {
            const url = new URL(window.location.href);
            url.searchParams.set('page', number);
            url.hash = grid.id;
            const link = document.createElement('a');
            link.href = url.href;
            link.textContent = text;
            link.setAttribute('aria-label', label);
            link.dataset.catalogPage = number;
            nav.append(link);
          };
          if (page > 1) addLink(page - 1, '←', nav.dataset.previousLabel);
          for (let number = 1; number <= pageCount; number++) {
            if (number === page) {
              const current = document.createElement('span');
              current.textContent = number;
              current.setAttribute('aria-current', 'page');
              nav.append(current);
            } else addLink(number, String(number), nav.dataset.pageLabel.replace('__PAGE__', number));
          }
          if (page < pageCount) addLink(page + 1, '→', nav.dataset.nextLabel);
        }
        delete root.dataset.quickAddReady;
        root.parentElement.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
        if (navigate) {
          const url = new URL(window.location.href);
          url.searchParams.set('page', page);
          url.hash = grid.id;
          window.history.pushState(null, '', url);
          grid.setAttribute('tabindex', '-1');
          grid.focus({ preventScroll: true });
          grid.scrollIntoView({ block: 'start' });
        }
      };
      if (cards.length) renderPage(initialPage);
      nav?.addEventListener('click', (event) => {
        const link = event.target.closest('[data-catalog-page]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        renderPage(Number(link.dataset.catalogPage), true);
      });
      window.addEventListener('popstate', () => {
        if (grid.isConnected) renderPage(Number(new URL(window.location.href).searchParams.get('page')) || 1);
      });
    } catch {
      grid.dataset.rankingFailed = 'true';
    } finally {
      grid.dataset.ranked = 'true';
      root.removeAttribute('aria-busy');
      if (status) status.hidden = true;
    }
  };
  const init = (scope) => {
    scope.querySelectorAll('[data-priority-grid]').forEach(prioritise);
    scope.querySelectorAll('[data-collection-sort]').forEach((form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const select = form.querySelector('select');
      const submit = form.querySelector('[data-sort-submit]');
      if (!select) return;
      if (submit) submit.hidden = true;
      select.addEventListener('change', () => form.requestSubmit());
    });
    scope.querySelectorAll('.inf-collection__filter-link').forEach((link) => {
      if (link.dataset.ready) return;
      link.dataset.ready = 'true';
      const panel = document.getElementById(link.hash.slice(1));
      if (panel) panel.dataset.enhanced = 'true';
      link.addEventListener('click', () => {
        const details = document.getElementById(link.hash.slice(1));
        if (details) {
          details.open = true;
          details.querySelector('summary')?.focus();
        }
      });
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
